import * as React from 'react';

export const TodayDeliveryIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='55'
    height='32'
    viewBox='0 0 3338 4163'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    ref={ref}
  >
    <g id='Picto_Today_Delivery'>
      <g id='Item_Color'>
        <path
          id='Vector 2'
          d='M1663.71 2265.05L2108.01 1083.99C2554.52 1232.53 3007.08 1760.76 2890.16 2434.31C2742.41 3285.52 2009.97 3491 1663.71 3488.83L1663.71 2265.05Z'
          fill='url(#paint0_linear_4_249)'
        />
      </g>
      <g id='Item_Black' fill='black'>
        <g id='Group'>
          <path
            id='Vector'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M2369.01 3269.55C2412.5 3240 2456.81 3261.01 2486.37 3304.48C2515.92 3347.95 2519.6 3397.56 2476.11 3427.11C2247.37 3582.57 1971.26 3673.49 1674.08 3673.49C885.351 3673.49 245 3033.19 245 2244.53C245 1455.86 885.351 815.561 1674.08 815.561C2462.81 815.561 3103.16 1455.86 3103.16 2244.53C3103.16 2297.09 3058.72 2327.17 3006.13 2327.17C2953.56 2327.17 2912.63 2297.09 2912.63 2244.53C2912.63 1561 2357.66 1006.07 1674.08 1006.07C990.503 1006.07 435.524 1561 435.524 2244.53C435.524 2928.04 990.503 3482.97 1674.08 3482.97C1931.57 3482.97 2170.82 3404.26 2369.01 3269.55Z'
          />
          <path
            id='Vector_2'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M1299.93 775.761C1221.07 775.761 1157.04 711.739 1157.04 632.881C1157.04 554.022 1221.07 490 1299.93 490H2020.75C2099.61 490 2163.64 554.022 2163.64 632.881C2163.64 711.739 2099.61 775.761 2020.75 775.761H1299.93Z'
          />
          <path
            id='Vector_3'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M2583.45 1057.57C2539.08 1009.1 2542.4 933.722 2590.88 889.349C2639.35 844.974 2714.75 848.298 2759.11 896.769L3154.74 1328.87C3199.11 1377.34 3195.78 1452.72 3147.32 1497.1C3098.83 1541.47 3023.45 1538.15 2979.07 1489.68L2583.45 1057.57Z'
          />
        </g>
        <path
          id='Vector_4'
          d='M1673.96 2992.93L1673.96 2190.99'
          stroke='black'
          strokeWidth='108.33'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_5'
          d='M1676.84 2183.93L1881.26 1687.85'
          stroke='black'
          strokeWidth='108.33'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <circle id='Vector_6' cx='1673.39' cy='2203.65' r='104.87' />
      </g>
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_4_249'
        x1='1703.65'
        y1='3489.33'
        x2='2577.09'
        y2='1376.46'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0.380509'
          stopColor='var(--primary-color)'
          stopOpacity='0.2'
        />
        <stop offset='1' stopColor='var(--primary-color)' />
      </linearGradient>
    </defs>
  </svg>
);
